module.exports = __webpack_public_path__ + "5.0.2/img/r_3_1.107b06a6.png";